import { Alert } from "antd";
import { ReactNode } from "react";

export interface CalloutProps {
    text: ReactNode;
    type: "info" | "warning" | "error";
    isClosable?: boolean;
    className?: string;
}

export const Callout = ({ text, type, isClosable, className }: CalloutProps) => {
    return (
        <div className={`Callout ${className ?? ""}`}>
            <Alert message={text} type={type} closable={isClosable} showIcon />
        </div>
    );
};
